import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { signOut } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDHT-FWlVKw9VjXabb5uex9n1XC23KaGqQ",
  authDomain: "coralis-tenants-app.firebaseapp.com",
  projectId: "coralis-tenants-app",
  storageBucket: "coralis-tenants-app.appspot.com",
  messagingSenderId: "954637038640",
  appId: "1:954637038640:web:46b9dae32afa67681329f5",
  measurementId: "G-Z2EPLEFDWF",
};

const firebaseApp = initializeApp(firebaseConfig);
const auth = getAuth(firebaseApp);

const useFirebase = () => {
  auth.currentUser
    ?.getIdToken(true)
    .then((tok) => {
      return tok;
    })
    .catch((e) => {
      console.log("error-useFirebase", e);
      signOut(auth);
    });

  const authUser = auth.currentUser;

  return { authUser };
};

export { auth, useFirebase };
